// extracted by mini-css-extract-plugin
export default {"mediaQueryMobile":"810","mediaQueryTablet":"1024","mediaQueryDesktop":"1440","container":"index-modules__container___nRWRf","block":"index-modules__block___Re48E"};